import angular from 'angular';

export class FooterComponent {
  $state;
  $scope;
  $rootScope;
  auth;

  constructor($state, $scope, $rootScope, Auth) {
    'ngInject';

    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.auth = Auth;
  }

  $onInit() {
  }

  logout() {
    this.auth.logout();
    this.$state.go('login');
  }
}

export default angular.module('directives.footer', [])
  .component('footer', {
    template: require('./footer.html'),
    controller: FooterComponent,
    controllerAs: 'footer'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/footer/footer.component.js